import { render, staticRenderFns } from "./FooterSlot.vue?vue&type=template&id=2d415fae&scoped=true"
import script from "./FooterSlot.vue?vue&type=script&lang=js"
export * from "./FooterSlot.vue?vue&type=script&lang=js"
import style0 from "./FooterSlot.vue?vue&type=style&index=0&id=2d415fae&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d415fae",
  null
  
)

export default component.exports